import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { IWatchdog } from "../types";

// import NumericInterval from "utils/NumericInterval";

type TInput = void;
type TOutput = Array<IWatchdog>;

export default class GetWatchdogsApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;

  resolveUri(): string {
    return `/fe-api/watchdogs`;
  }

  mapResponseData(_status: number, data: any): TOutput {
    return data.map(
      (x: any): IWatchdog => ({
        id: x.id,
        name: x.name,
        frequencyId: x.frequency_id,
        filter: {
          ...x.filter,
          priceFrom: x.filter.price_from,
          priceTo: x.filter.price_to,
          acreageFrom: x.filter.acreage_from,
          acreageTo: x.filter.acreage_to,
          offerTypeId: x.filter.offer_type_id,
          bounds: {
            northEast: {
              lat: x.filter.bounds.north_east.lat,
              lng: x.filter.bounds.north_east.lng,
            },
            southWest: {
              lat: x.filter.bounds.south_west.lat,
              lng: x.filter.bounds.south_west.lng,
            },
          },
        },

        // FIXME:
        // filter: null as any,
        // filter: {
        //   // FIXME: tyto struktury nesedi s novyma (viz cofig)
        //   dispositions: x.search.dispositions,
        //   // HACK: BE returns ugly numbers when price/area is not set
        //   price: new NumericInterval(
        //     x.search.price_from === 0 ? null : x.search.price_from,
        //     x.search.price_to === 16123123 ? null : x.search.price_to,
        //   ),
        //   area: new NumericInterval(
        //     x.search.acreage_from === 0 ? null : x.search.acreage_from,
        //     x.search.acreage_to === 64123 ? null : x.search.acreage_to,
        //   ),
        //   furnishing: x.search.furnishing,
        //   conveniences: x.search.conveniences,
        //   offerAge: null as any,
        // },
      }),
    );
  }
}
